export const DEFAULT_STORE = 'DEFAULT_STORE'
export const LIST_BRANCH = 'LIST_BRANCH'
export const IS_IPP = 'IS_IPP'
export const CLEAR_BRANCH = 'CLEAR_BRANCH'
